import React from "react";

export const Pill = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="md:cw-text-sm cw-text-xs cw-text-muted cw-rounded-full cw-bg-neutral-inset cw-mr-4 cw-ml-1 cw-px-2 cw-py-0.5">
      {children}
    </div>
  );
};
